import React, { Component, Fragment } from 'react'
import {Typography, Container, Grid, IconButton, Box } from '@material-ui/core';
import Image from './Image'
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

const getSocialMediaIcon = (icon) => {
    switch(icon) {
      case 'linkedin':
        return <LinkedInIcon />
      case 'instagram':
        return <InstagramIcon />
      case 'facebook':
        return <FacebookIcon />
      case 'youtube':
        return <YouTubeIcon />
      default:
        return null;
    }
  }

const FooterBottom = (props) => {

    return (
        <div {...props}>
            <div className="page-maxwidth">
                <Container maxWidth="xl">
                    <Grid container spacing={1}>
                        <Grid item md={2}>
                            <Image img={`${props.client.name}/logo.png`} alt={props.client.nameCopy} />
                        </Grid>
                        <Grid item md={10} className="text-right">
                            {props.contacto.redesSociales&&  <>
                                <h4 className="titleLinks">Redes Sociales</h4>
                                {props.contacto.redesSociales?.map((network, i) => (
                                    <IconButton key={i} href={network.link} target='_blank' className='network'>
                                        {getSocialMediaIcon(network.icon)}
                                    </IconButton>
                                ))}
                            </> }
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={7}>
                            <Grid container spacing={2}>
                                {props.menu && props.menu.map((menu, i) => (		
                                    <Fragment key={i}>
                                        <Grid item md={4}>
                                            <h4 className="titleLinks">{menu.principal}</h4>
                                            <ul className="list-unstyled">
                                                {menu.submenu.map((submenu, i) => (		 
                                                    <li key={i}><a href={submenu.urlSite==='no'?submenu.link:`${props.client.urlSite}/${submenu.link}`}>{submenu.clave}</a></li>
                                                ))}
                                            </ul>
                                        </Grid>
                                    </Fragment>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid item md={5}>
                            <Grid container spacing={2} >
                                <Grid item md={6}> 
                                    

                                    {props.contacto?.whatsappGuardia?.length > 0 && (
                                        <div className='datos-contacto'>
                                            <h4 className="titleLinks" style={{display:'flex', alignItems: 'center', marginBottom: 4}}><WhatsAppIcon /> Guardia:</h4>
                                            <ul className="list-unstyled">
                                                {props.contacto?.whatsappGuardia?.map((whatsapp, i) => (		 
                                                    <li key={i}>{whatsapp}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {props.contacto?.whatsappVentas?.length > 0 && (
                                        <div className='datos-contacto'>
                                            <h4 className="titleLinks" style={{display:'flex', alignItems: 'center', marginBottom: 4}}><WhatsAppIcon /> Ventas:</h4>
                                            <ul className="list-unstyled">
                                                {props.contacto?.whatsappVentas?.map((whatsapp, i) => (		 
                                                    <li key={i}>{whatsapp}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </Grid>
                
                                <Grid item md={12}>
                                    <div className={`text-right media-container`}>
                                        <div className="datos-contacto">
                                            <h4 className="title">{props.contacto.translate_Tienesdudas}</h4>
                                            <ul className="list-unstyled">
                                                {props.contacto.sucursales.map((contacto, i) => (	
                                                    <li key={i}>
                                                        {contacto.sucursal}  <span className="strong"> {contacto.telefono} </span>
                                                        {contacto.email && <Fragment><br />{contacto.email} <br /></Fragment>}    
                                                        {contacto.web && <Fragment>{contacto.web} <br /></Fragment>}
                                                        {contacto.legajo && <Fragment>{contacto.legajo}</Fragment>}  
                                                    </li>
                                                    
                                                ))}
                                            </ul>  
                                            <br/>                              

                                            {props.email && <div>{props.email}</div>} 

                                          

                                           
                                        </div>
                                        {props.contacto.sublegales && <div>{props.contacto.sublegales}</div>}    
                                    </div>
                                </Grid>     

                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </div>
    )
}
const Legales = (props) => {

    return (
        <div {...props}>
            <div className="page-maxwidth">
                <Container maxWidth="xl">

                    <Box display="flex">
                        <Box>
                                <div className="cont-certificados">
                                <ul className="list-unstyled list-inline">
                                    {props.logos.map((logo, i) => (	
                                        <li key={i} className="list-inline-item" >
                                            <a href={logo.url}><Image img={`${props.client.name}/${logo.img}`} alt={logo.alt} /></a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Box>
                        <Box flexGrow={1}>
                            <div className="copyrightContainer">                          
                                <Typography className="copyright">{props.legales}</Typography>   
                            </div>
                        </Box>
                        <Box item>
                            <div className="list-unstyled d-inline bloq-banderas">
                                {props.banderas?.map((bandera, i) => (	
                                    <div key={i} ><Image img={`${props.client.name}/${bandera.img}`} alt={bandera.alt} /></div>
                                ))}
                            </div>
                        </Box>
                    </Box>
                </Container>
            </div>
        </div>
    )
}

class Footer extends Component {
    render() {
        return (
            <footer className="footer">
                <FooterBottom 
                    client={this.props.client}
                    menu={this.props.data.menu} 
                    contacto={this.props.data.contacto} 
                    email={this.props.data.email}
                    className="footerBottom" 
                />

                {this.props.data.legalesFooter?
     
                <Legales className="legals" 
                    client={this.props.client}
                    logos={this.props.data.logos} 
                    legales={this.props.data.legales}  
                    banderas={this.props.data.banderas}
                />
                :''}                
            </footer>
        )
    }
}
export default Footer;
